<template>
  <div class="landing" fluid fill-height>
    <div v-if="!error">
      <v-progress-linear indeterminate color="accent" height="60"></v-progress-linear>
      <v-card-text class="text-subtitle-1 text-center">
        {{ $t('message.loading_admin') }}
      </v-card-text>
    </div>
    <v-card-text v-if="error" class="text-center">
      <div class="error--text pa-2 text-h5">{{ error }}</div>
      <div class="error--text pa-2 text-h6">{{ $t('message.restart_app') }}</div>
    </v-card-text>
  </div>
</template>

<script>
import Api from "@/services/Api";


export default {
  data() {
    return {
      token: this.$route.params.token,
      appVersion: this.$route.query.appv,
      redirect: this.$route.query.r,
      embed: this.$route.query.embed,
      lat: this.$route.query.lat,
      lon: this.$route.query.lon,
      closeAndReload: false,
      error: null,
    }
  },
  created() {
    if (localStorage.token) {
      window.location = process.env.VUE_APP_PUBLIC_PATH;
    } else {
      this.login();
    }
  },
  methods: {
    reload() {
      window.location.reload(true);
    },
    async login() {
      try {
        if (this.token) {
          console.log('Starting login with token: ', this.token);
          Api()
            .post(
              "users/authapp", {
              token: this.token,
              appVersion: this.appVersion ? this.appVersion : null
            })
            .then((response) => {
              if (response)
                this.processLoggedIn(response);
              else
                this.error = this.$t("message.invalid_user") + ": TLGN01";
            }).catch((err) => {
              console.log('HERE')
              if (err.response) {
                if (err.response.status == 404)
                  this.error = this.$t("message.invalid_user") + ": TLGN02";
                else if (err.response.status == 400)
                  this.error = this.$t("message.invalid_password") + ": TLGN03";
                else
                  this.error = this.$t("message.error_generic") + ": TLGN04";
              } else {
                console.log('HERE3')
                this.error = this.$t("message.error_generic") + ": TLGN05";
              }
            });
        } else {
          this.error = this.$t("message.error_generic") + ": TLGN06";
        }
      } catch (err) {
        console.lof('Error loging in: ', err);
        this.error = this.$t("message.error_generic") + ": TLGN07";
      }
    },
    processLoggedIn(response) {
      if (response.data.token) {
        try {
          // 1. YOUR ORIGINAL DATA SAVING
          this.$store.dispatch("setToken", response.data.token);
          this.$store.dispatch("setUser", response.data.user);
          this.$store.dispatch("setName", response.data.user.fName);
          this.$store.dispatch("setInApp", true);
          this.$store.dispatch("setManagedAcademy", response.data.user.managedAcademy);

          this.$store.dispatch("setUserImage",
            (response.data.user.userImageSmall ?
              response.data.user.userImageSmall :
              response.data.user.userImage));

          this.$store.dispatch("setLanguage", response.data.user.lang);
          this.$i18n.locale = response.data.user.lang;
          localStorage.token = response.data.token;

          // 2. YOUR AGREEMENT LOGIC
          if (response.data.hasLatestAgreement && response.data.hasLatestAgreement == true) {
            localStorage.hasAgreements = true;
            this.$store.dispatch("setHasAgreements", true);
          } else {
            localStorage.hasAgreements = false;
            this.$store.dispatch("setHasAgreements", false);
          }

          // 3. THE REDIRECT LOGIC
          // We force a page reload to /secure/home. 
          // This is the "Safety Reset" that prevents the Stack Overflow 
          // and ensures App.js restarts with all the data we just saved.
          console.log('Login success. Forcing clean boot to Home.');
          window.location.href = "/secure/home";

        } catch (err) {
          console.error("Login Error: ", err);
          this.error = this.$t("message.error_generic") + ": TLGN08";
        }
      } else {
        this.error = this.$t("message.error_generic") + ": TLGN09";
      }
    }
  }
}
</script>

<style scoped></style>